import { Image } from "@chakra-ui/react";

export const IconCustom = (props: { fileName; onClick?, size? }) => {
  return (
    <Image
      src={`/assets/${props.fileName}.svg`}
      w={props.size || "24px"}
      h={props.size || "24px"}
      cursor={"pointer"}
      onClick={props.onClick}
    />
  );
};
